import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize } from 'rxjs/operators';
import firebase from 'firebase/compat/app';
import { Address } from 'src/app/models/address.model';

import 'firebase/firestore';
import * as geofirestore from 'geofirestore';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  firestore = firebase.firestore();
  GeoFirestore = geofirestore.initializeApp(this.firestore);

  constructor(
    private adb: AngularFirestore,
    private fireStoreage: AngularFireStorage
  ) { }

  collection(path, queryFn?) {
    return this.adb.collection(path, queryFn);
  }

  geoCollection(path: string) {
    return this.GeoFirestore.collection(path);
  }

  getTimestamp() {
    return firebase.firestore.FieldValue.serverTimestamp;
  }


  async getCollection(collection: string, order: { field: any, value: any }, lastDoc){
    try {
      const snap = await this.adb.collection(collection).ref
      .orderBy(order.field, order.value)
      .startAfter(lastDoc)
      .limit(25)
      .get();

      if (snap.docs.length == 0) return null;
      let newLastDoc = snap.docs[snap.docs.length - 1];
      const data = snap.docs.map((element: any) => {
        let res = element.data();
        res.id = element.id;
        return res;
      });
      console.log(data);

      return { data: data, lastDoc: newLastDoc }

    } catch (e) {
      console.log(e);
      throw (e);
    }
  }


  async getCollectionBy1Param(collection: string, param: { field: any, value: any }, order: { field: any, value: any }, lastDoc) {
    try {
      const snap = await this.adb.collection(collection).ref
        .where(param.field, '==', param.value)
        .orderBy(order.field, order.value)
        .startAfter(lastDoc)
        .limit(25)
        .get();

      if (snap.docs.length == 0) return null;
      let newLastDoc = snap.docs[snap.docs.length - 1];
      const data = snap.docs.map((element: any) => {
        let res = element.data();
        res.id = element.id;
        return res;
      });

      return { data: data, lastDoc: newLastDoc }
    } catch (e) {
      console.log(e);
      throw (e);
    }
  }


  async getCollectionBy2Param(collection: string, param1: { field: any, value: any }, param2: { field: any, value: any }, order: { field: any, value: any }, limit,  lastDoc) {
    try {

      const snap = await this.adb.collection(collection).ref
        .where(param1.field, '==', param1.value)
        .where(param2.field, '==', param2.value)
        .orderBy(order.field, order.value)
        .startAfter(lastDoc)
        .limit(limit)
        .get();

      if (snap.docs.length == 0) return null;
      let newLastDoc = snap.docs[snap.docs.length - 1];
      const data = snap.docs.map((element: any) => {
        let res = element.data();
        res.id = element.id;
        return res;
      });

      return { data: data, lastDoc: newLastDoc }
    } catch (e) {
      throw (e);
    }
  }

  async fetchSetOfDataByIdList(collection, array) {
    try {
      const data = await (this.adb.collection(collection).ref
        .where(firebase.firestore.FieldPath.documentId(), 'in', array)
        .get()).then(res => {
          if (res.docs.length == 0) return null;

          return res.docs.map((element: any) => {
            let res = element.data();
            res.id = element.id;
            return res;
          });
        });
      return data;
    } catch (e) {
      throw (e);
    }
  }

  async getNearByOffersForMap(lat, lng, distance): Promise<any> {
    try {
      const center = new firebase.firestore.GeoPoint(lat, lng);
      const data = (
        await this.geoCollection('offers')
          .near({ center, radius: distance })
          .get()).docs.sort((a, b) => a.distance - b.distance)
        .map(element => {
          let offer = element.data();
          offer.id = element.id;
          offer.distance = element.distance;
          return offer;
        });
      return data;
    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  lastDistance = 1;
  async getNearByOffersForList(lat, lng, distance): Promise<any> {
    try {
      const center = new firebase.firestore.GeoPoint(lat, lng);
      const data = (
        await this.geoCollection('offers')
          .near({ center, radius: distance })
          .get()
      ).docs.sort((a, b) => a.distance - b.distance)
        .map(element => {
          let offer = element.data();
          offer.id = element.id;
          offer.distance = element.distance;

          this.lastDistance += 1;
          return offer;
        });
      return data;
    } catch (e) {
      throw (e);
    }
  }



  uploadImages(files: any, folderName?: string, base64Data?: boolean) {
    return new Promise((resolve, reject) => {
      if (files.length == 0) reject();
      const urls: string[] = [];

      for (const file of files) {
        const path = (folderName ? folderName : '') + Date.now() + '_' + file.name;
        const ref = this.fireStoreage.ref(path);
        if (base64Data)
          ref.putString(file.file, 'base64', { contentType: 'image/jpeg' })
        const task = this.fireStoreage.upload(path, file);

        task.snapshotChanges().pipe(
          finalize(() => {
            ref.getDownloadURL().subscribe(url => {
              urls.push(url);

              if (files.length === urls.length) {
                resolve(urls);
              }
            });
          })
        ).subscribe();
      }
    });
  }

  deleteImg(img_url: string) {
    return new Promise((resolve, reject) => {
      this.fireStoreage.refFromURL(img_url).delete()
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err)
          }
        );
    });
  }

  async deleteAccountInfo(uid) {
    this.adb.collection('users').doc(uid).delete().catch(e => { throw (e) })
  }

  async deleteOffer(id: string, imgs: string[], DBCollection: string) {
    try {
      let count = 0;
      const deleteImags = async (imagesArr: string[]) => {

        if (imgs.length != 0) { // Delete Images of offer
          const promises = [];
          for (let i = 0; i < imagesArr.length; i++)
            if (imagesArr.includes("firebasestorage.googleapis.com")){
              promises.push(this.deleteImg(imagesArr[i]));
              count++;
            }
          return promises;
        }
      }

      // delete Images and  offer
      if(count > 0) await Promise.all( await deleteImags(imgs));
      await this.adb.collection(DBCollection).doc(id).delete();

      console.log('Delete Offer Completed');

    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  async inactivateOffer(id, inactivateOffer) {
    try {
      await this.adb.collection("inactive-offers").doc(id).set(inactivateOffer);
      await this.adb.collection('offers').doc(id).delete();
    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  async activateOffer(id, activateOffer) {
    try {
      await this.adb.collection("offers").doc(id).set(activateOffer);
      await this.adb.collection('inactive-offers').doc(id).delete();
    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  async updateAddress(num: number, address: Address) {
    try {
      await this.increment_decrement(num, 'countries', address.country, address.country);
      await this.increment_decrement(num, 'countries', address.country, address.state);
      await this.increment_decrement(num, 'countries', address.country, address.region);

    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  async increment_decrement(num: number, path: string, id: string, fieldName: string) {
    try {
      let field = {};
      const val = firebase.firestore.FieldValue.increment(num);
      field[fieldName] = val;
      this.collection(path).doc(id).update(field);
    } catch (e) {
      throw (e);
    }
  }







}
